module.exports = __webpack_public_path__ + "static/media/xiangshan_package.252bc443.webp";